import usePaginated from './api/usePaginated'
import useUser from './useUser'

export default function useStamps(filters = {}, shouldFetch = true) {
  const { user } = useUser()
  const { items, ...attributes } = usePaginated(
    () => (shouldFetch && user ? '/api/stamps' : null),
    (response) => response?.stamps,
    filters,
    {
      refreshInterval: 3600000,
      dedupingInterval: 3600000,
    }
  )

  return {
    stamps: items,
    ...attributes,
  }
}
